export default {
  SET_OWNER_BY_ENTITY(state, payload) {
    state.ownerByEntity = payload
  }
}